<template>
  <v-container
    class="product-create create-form white-background main-create-page"
  >
    <v-layout>
      <v-flex md6>
        <h1 class="form-title d-flex">
          <template v-if="product_id">Update</template
          ><template v-else>Create</template> Product
        </h1>
      </v-flex>
      <v-flex md6 class="text-right">
        <v-btn
          :disabled="!form_valid || form_loading"
          :loading="form_loading"
          class="mx-2 custom-bold-button text-white"
          color="cyan"
          v-on:click="update_or_create()"
        >
          <template v-if="product_id">Update</template
          ><template v-else>Create</template> Product
        </v-btn>
        <v-btn
          v-on:click="goBack"
          :disabled="form_loading"
          class="mx-2 custom-grey-border custom-bold-button"
          outlined
          >Cancel
        </v-btn>
      </v-flex>
    </v-layout>
    <v-container style="overflow-y: auto; min-height: calc(100vh - 110px)">
      <v-row class="mx-0 product-create-form">
        <v-col md="9" sm="12">
          <v-form
            ref="product_form"
            v-model.trim="form_valid"
            lazy-validation
            v-on:submit.stop.prevent="updateOrCreate"
          >
            <table width="100%">
              <tr>
                <td valign="middle" width="15%">
                  <label class="font-weight-700 required font-size-16 width-100"
                    >Name</label
                  >
                </td>
                <td valign="middle" width="35%">
                  <v-text-field
                    dense
                    filled
                    label="Name"
                    solo
                    flat
                    class="width-100"
                    color="cyan"
                    v-model.trim="product_create.name"
                    :rules="[
                      validateRules.required(product_create.name, 'Name'),
                      validateRules.minLength(product_create.name, 'Name', 1),
                      validateRules.maxLength(product_create.name, 'Name', 100),
                    ]"
                    hide-details
                  ></v-text-field>
                </td>
                <td valign="middle" width="15%">
                  <label class="font-weight-700 required font-size-16 width-100"
                    >Serial Number</label
                  >
                </td>
                <td valign="middle" width="35%">
                  <v-text-field
                    dense
                    filled
                    label="Serial Number"
                    solo
                    flat
                    class="width-100"
                    color="cyan"
                    v-model.trim="product_create.serial_number"
                    :rules="[
                      validateRules.required(
                        product_create.serial_number,
                        'Serial Number'
                      ),
                      validateRules.minLength(
                        product_create.serial_number,
                        'Serial Number',
                        1
                      ),
                      validateRules.maxLength(
                        product_create.serial_number,
                        'Serial Number',
                        100
                      ),
                    ]"
                    hide-details
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td valign="top">
                  <label class="pt-2 font-weight-700 font-size-16 width-100"
                    >Description</label
                  >
                </td>
                <td colspan="3" valign="middle">
                  <v-textarea
                    dense
                    filled
                    label="Description"
                    solo
                    flat
                    row-height="20"
                    auto-grow
                    color="cyan"
                    v-model.trim="product_create.description"
                    :rules="[
                      validateRules.minLength(
                        product_create.description,
                        'Description',
                        1
                      ),
                      validateRules.maxLength(
                        product_create.description,
                        'Description',
                        1024
                      ),
                    ]"
                  ></v-textarea>
                </td>
              </tr>
              <tr>
                <td valign="middle" width="15%">
                  <label class="font-weight-700 font-size-16 width-100"
                    >Part Number</label
                  >
                </td>
                <td valign="middle" width="35%">
                  <v-text-field
                    dense
                    filled
                    label="Part Number"
                    solo
                    flat
                    class="width-100"
                    color="cyan"
                    v-model.trim="product_create.part_number"
                    :rules="[
                      validateRules.minLength(
                        product_create.part_number,
                        'Part Number',
                        1
                      ),
                      validateRules.maxLength(
                        product_create.part_number,
                        'Part Number',
                        100
                      ),
                    ]"
                    hide-details
                  ></v-text-field>
                </td>
                <td valign="middle" width="15%">
                  <label class="font-weight-700 font-size-16 width-100"
                    >Product #</label
                  >
                </td>
                <td valign="middle" width="35%">
                  <v-text-field
                    dense
                    filled
                    label="Product #"
                    solo
                    flat
                    class="width-100"
                    color="cyan"
                    readonly
                    v-model.trim="product_create.barcode"
                    hide-details
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td valign="middle" width="15%">
                  <label class="font-weight-700 font-size-16 width-100"
                    >Re-Order Level</label
                  >
                </td>
                <td valign="middle" width="35%">
                  <v-text-field
                    dense
                    filled
                    label="Re-Order Level"
                    solo
                    flat
                    class="width-100"
                    color="cyan"
                    v-model.trim="product_create.reorder_level"
                    hide-details
                  ></v-text-field>
                </td>
                <td valign="middle" width="15%">
                  <label class="font-weight-700 font-size-16 width-100"
                    >Unit</label
                  >
                </td>
                <td valign="middle" width="35%">
                  <v-autocomplete
                    dense
                    filled
                    color="cyan"
                    item-color="cyan"
                    :items="unit_list"
                    label="Unit"
                    solo
                    flat
                    hide-details
                    append-outer-icon="mdi-cog"
                    v-on:click:append-outer="manage_unit_dialog = true"
                    item-text="text"
                    item-value="id"
                    class="width-100"
                    v-model.trim="product_create.unit"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="'No Unit Found.'"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </td>
              </tr>
              <tr>
                <td valign="middle" width="15%">
                  <label class="font-weight-700 font-size-16 width-100"
                    >Manufacturer</label
                  >
                </td>
                <td valign="middle" width="35%">
                  <v-autocomplete
                    dense
                    filled
                    color="cyan"
                    item-color="cyan"
                    :items="manufacturer_list"
                    label="Manufacturer"
                    solo
                    flat
                    hide-details
                    append-outer-icon="mdi-cog"
                    v-on:click:append-outer="manage_manufacturer_dialog = true"
                    item-text="text"
                    item-value="id"
                    class="width-100"
                    v-model.trim="product_create.manufacturer"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="'No Manufacturer Found.'"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </td>
                <td valign="middle" width="15%">
                  <label class="font-weight-700 font-size-16 width-100"
                    >Brand</label
                  >
                </td>
                <td valign="middle" width="35%">
                  <v-autocomplete
                    dense
                    filled
                    color="cyan"
                    item-color="cyan"
                    :items="brand_list"
                    label="Brand"
                    solo
                    flat
                    hide-details
                    append-outer-icon="mdi-cog"
                    v-on:click:append-outer="manage_brand_dialog = true"
                    item-text="text"
                    item-value="id"
                    class="width-100"
                    v-model.trim="product_create.brand"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="'No Brand Found.'"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </td>
              </tr>
              <tr>
                <td valign="middle" width="15%">
                  <label class="font-weight-700 font-size-16 width-100"
                    >Category</label
                  >
                </td>
                <td valign="middle" width="35%">
                  <v-autocomplete
                    dense
                    filled
                    color="cyan"
                    item-color="cyan"
                    :items="category_list"
                    label="Category"
                    solo
                    flat
                    hide-details
                    append-outer-icon="mdi-cog"
                    v-on:click:append-outer="manage_category_dialog = true"
                    item-text="text"
                    item-value="id"
                    class="width-100"
                    v-model.trim="product_create.category"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="'No Category Found.'"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>
                </td>
                <td valign="middle" width="15%">
                  <label class="font-weight-700 font-size-16 width-100"
                    >Initial Stock</label
                  >
                </td>
                <td valign="middle" width="35%">
                  <v-text-field
                    dense
                    filled
                    label="Initial Stock"
                    solo
                    flat
                    class="width-100"
                    color="cyan"
                    v-model.trim="product_create.initial_stock"
                    hide-details
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td valign="middle" width="15%">
                  <label class="font-weight-700 font-size-16 width-100"
                    >Purchase Cost</label
                  >
                </td>
                <td valign="middle" width="35%">
                  <v-text-field
                    dense
                    filled
                    label="Purchase Cost"
                    solo
                    flat
                    class="width-100"
                    color="cyan"
                    v-model.trim="product_create.purchase_cost"
                    hide-details
                    type="number"
                    min="0"
                    max="9999"
                    v-on:keypress="
                      limitDecimal($event, product_create.purchase_cost)
                    "
                    prepend-inner-icon="mdi-currency-usd"
                  ></v-text-field>
                </td>
                <td valign="middle" width="15%">
                  <label class="font-weight-700 font-size-16 width-100"
                    >Selling Cost</label
                  >
                </td>
                <td valign="middle" width="35%">
                  <v-text-field
                    dense
                    filled
                    label="Selling Cost"
                    solo
                    flat
                    class="width-100"
                    color="cyan"
                    v-model.trim="product_create.selling_cost"
                    hide-details
                    type="number"
                    min="0"
                    max="9999"
                    v-on:keypress="
                      limitDecimal($event, product_create.selling_cost)
                    "
                    prepend-inner-icon="mdi-currency-usd"
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td valign="middle" width="15%">
                  <label class="font-weight-700 font-size-16 width-100"
                    >Weight</label
                  >
                </td>
                <td valign="middle" width="35%">
                  <v-text-field
                    dense
                    filled
                    label="Weight"
                    solo
                    flat
                    class="width-100"
                    color="cyan"
                    v-model.trim="product_create.weight"
                    hide-details
                    type="number"
                    min="0"
                    max="9999"
                    v-on:keypress="limitDecimal($event, product_create.weight)"
                  ></v-text-field>
                </td>
                <td valign="middle" width="15%">
                  <label class="font-weight-700 font-size-16 width-100"
                    >Length</label
                  >
                </td>
                <td valign="middle" width="35%">
                  <v-text-field
                    dense
                    filled
                    label="Length"
                    solo
                    flat
                    class="width-100"
                    color="cyan"
                    v-model.trim="product_create.length"
                    hide-details
                    type="number"
                    min="0"
                    max="9999"
                    v-on:keypress="limitDecimal($event, product_create.length)"
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td valign="middle" width="15%">
                  <label class="font-weight-700 font-size-16 width-100"
                    >Width</label
                  >
                </td>
                <td valign="middle" width="35%">
                  <v-text-field
                    dense
                    filled
                    label="Width"
                    solo
                    flat
                    class="width-100"
                    color="cyan"
                    v-model.trim="product_create.width"
                    hide-details
                    type="number"
                    min="0"
                    max="9999"
                    v-on:keypress="limitDecimal($event, product_create.width)"
                  ></v-text-field>
                </td>
                <td valign="middle" width="15%">
                  <label class="font-weight-700 font-size-16 width-100"
                    >Height</label
                  >
                </td>
                <td valign="middle" width="35%">
                  <v-text-field
                    dense
                    filled
                    label="Height"
                    solo
                    flat
                    class="width-100"
                    color="cyan"
                    v-model.trim="product_create.height"
                    hide-details
                    type="number"
                    min="0"
                    max="9999"
                    v-on:keypress="limitDecimal($event, product_create.height)"
                  ></v-text-field>
                </td>
              </tr>
              <tr>
                <td colspan="4" valign="middle">
                  <label class="font-weight-700 font-size-18 width-100"
                    >Images
                    <v-tooltip top content-class="custom-top-tooltip">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon small class="mx-2" v-bind="attrs" v-on="on"
                          >mdi-progress-question</v-icon
                        >
                      </template>
                      <span>More than 5 images are not allowed</span>
                    </v-tooltip>
                  </label>
                </td>
              </tr>
              <tr>
                <td colspan="4" valign="middle">
                  <div>
                    <FileTemplate
                      allow-upload
                      is-min-display
                      :attachments="product_create.product_images"
                      v-on:file:updated="update_images"
                    ></FileTemplate>
                  </div>
                </td>
              </tr>
            </table>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <ManageBrand
      :dialog="manage_brand_dialog"
      :brand="brand_list"
      v-on:close-dialog="manage_brand_dialog = false"
      v-on:get-product-brand="get_options()"
    ></ManageBrand>
    <ManageManufacturer
      :dialog="manage_manufacturer_dialog"
      :manufacturer="manufacturer_list"
      v-on:close-dialog="manage_manufacturer_dialog = false"
      v-on:get-product-manufacturer="get_options()"
    ></ManageManufacturer>
    <ManageCategory
      product
      :dialog="manage_category_dialog"
      :category="category_list"
      v-on:close-dialog="manage_category_dialog = false"
      v-on:get-product-category="get_options()"
    ></ManageCategory>
    <ManageUnit
      :dialog="manage_unit_dialog"
      :unit="unit_list"
      v-on:close-dialog="manage_unit_dialog = false"
      v-on:get-product-unit="get_options()"
    ></ManageUnit>
  </v-container>
</template>
<script>
import ValidationMixin from "@/core/plugins/validation-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import FileTemplate from "@/view/pages/partials/FileTemplate.vue";
import ManageBrand from "@/view/pages/partials/Manage-Product-Brand.vue";
import ManageManufacturer from "@/view/pages/partials/Manage-Product-Manufacturer.vue";
import ManageCategory from "@/view/pages/partials/Manage-Product-Category.vue";
import ManageUnit from "@/view/pages/partials/Manage-Product-Unit.vue";
import {
  POST,
  GET,
  PUT,
  CLEAR_ERROR,
  UPDATE_ERROR,
} from "@/core/services/store/request.module";
import ObjectPath from "object-path";

export default {
  mixins: [ValidationMixin],
  name: "create-product",
  data() {
    return {
      product_id: 0,
      form_valid: true,
      form_loading: false,
      manage_unit_dialog: false,
      manage_manufacturer_dialog: false,
      manage_brand_dialog: false,
      manage_category_dialog: false,
      unit_list: [],
      manufacturer_list: [],
      brand_list: [],
      category_list: [],
      product_create: {
        product: null,
        name: null,
        reference: null,
        serial_number: null,
        description: null,
        part_number: null,
        barcode: null,
        reorder_level: null,
        unit: null,
        manufacturer: null,
        brand: null,
        category: null,
        initial_stock: null,
        purchase_cost: null,
        selling_cost: null,
        weight: null,
        length: null,
        width: null,
        height: null,
        manage_stock: true,
        track_batch: false,
        accounting: "none",
        product_type: "goods",
        taxable: false,
        sellable: true,
        confirmed: true,
        images: [],
        product_images: [],
      },
    };
  },
  methods: {
    update_or_create() {
      const _this = this;

      if (!_this.$refs.product_form.validate()) {
        return false;
      }

      _this.form_loading = true;
      _this.$store.dispatch(CLEAR_ERROR, {});

      let requestType = POST;
      let requestURL = "product";

      if (_this.product_id && _this.product_id > 0) {
        requestType = PUT;
        requestURL = "product/" + _this.product_id;
      }

      _this.$store
        .dispatch(requestType, { url: requestURL, data: _this.product_create })
        .then((response) => {
          _this.product_id = ObjectPath.get(response, "data.id", 0);

          _this.$router.push(
            _this.getDefaultRoute("product", {
              query: {
                status: "all",
              },
            })
          );
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.form_loading = false;
        });
    },
    load_content() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: `product/${_this.product_id}` })
        .then((response) => {
          const product = ObjectPath.get(response, "data", {});

          _this.product_create.product = product.product; //: null,
          _this.product_create.name = product.name; //: null,
          _this.product_create.reference = product.reference; //: null,
          _this.product_create.serial_number = product.serial_number; //: null,
          _this.product_create.description = product.description; //: null,
          _this.product_create.part_number = product.part_number; //: null,
          _this.product_create.barcode = product.barcode; //: null,
          _this.product_create.reorder_level = product.reorder_level; //: null,
          _this.product_create.unit = ObjectPath.get(product, "unit.id", 0); //: null,
          _this.product_create.manufacturer = ObjectPath.get(
            product,
            "manufacturer.id",
            0
          ); //: null,
          _this.product_create.brand = ObjectPath.get(product, "brand.id", 0); //: null,
          _this.product_create.category = ObjectPath.get(
            product,
            "category.id",
            0
          ); //: null,
          _this.product_create.initial_stock = product.initial_stock; //: null,
          _this.product_create.purchase_cost = product.purchase_cost; //: null,
          _this.product_create.selling_cost = product.selling_cost; //: null,
          _this.product_create.weight = product.weight; //: null,
          _this.product_create.length = product.length; //: null,
          _this.product_create.width = product.width; //: null,
          _this.product_create.height = product.height; //: null,
          _this.product_create.product_images = product.product_images; //: [],

          _this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Product", route: "product" },
            { title: product.barcode },
            { title: "Update" },
          ]);
        })
        .catch((error) => {
          _this.$store.dispatch(UPDATE_ERROR, error);
        });
    },
    update_images(param) {
      this.product_create.images = param;
    },
    get_options() {
      this.$store
        .dispatch(GET, { url: `product/options?product_type=goods` })
        .then((response) => {
          const output = ObjectPath.get(response, "data", {});
          this.product_create.barcode = output.barcode;
          if (!this.product_create.serial_number) {
            this.product_create.serial_number = output.serial_number;
          }
          this.brand_list = output.brand;
          this.manufacturer_list = output.manufacturer;
          this.unit_list = output.unit;
          this.category_list = output.category;
        })
        .catch((error) => {
          this.$store.dispatch(UPDATE_ERROR, error);
        })
        .finally(() => {
          if (this.product_id > 0) {
            this.load_content();
          }
        });
    },
  },
  components: {
    FileTemplate,
    ManageBrand,
    ManageManufacturer,
    ManageCategory,
    ManageUnit,
  },
  created() {
    this.product_id = this.lodash.toSafeInteger(this.$route.params.id);
  },
  mounted() {
    this.get_options();

    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Product", route: "product" },
      { title: "Create" },
    ]);
  },
};
</script>
